import React from "react";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import InputName from "../../../common/Input/InputName";
import InputNumber from "../../../common/Input/InputPhNumber";
import InputEmail from "../../../common/Input/InputEmail";
import InputPINCode from "../../../common/Input/InputPinCode";

const ProfileAddEdit = ({
  clinicProfileData,
  handleInputChange,
  handleSelectChange,
  Country,
  cities,
  state,
  deleteModal,
  setDeleteModal,
  handleUpdate,
  setInputError
}) => {
  return (
    <>
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6">
              <InputName
                  name="clinicName"
                  value={clinicProfileData.clinicName}
                  onChange={handleInputChange}
                  label="Clinic Name"
                  required={true}
                  placeholder="Enter Clinic Name"
                  fieldName="clinic name"
                  setInputNameError={setInputError} />
              </div>
              <div className="col-md-6">
              <InputNumber
                  name="phone"
                  value={clinicProfileData.phone}
                  onChange={handleInputChange}
                  label="Clinic Phone"
                  fieldName="phone"
                  setInputNumberError={setInputError} 
                  placeholder="Enter Clinic Phone"
                  required={true}/>
              </div>
              <div className="col-md-6">
              <InputNumber
                  name="alternateClinicPhone"
                  value={clinicProfileData.alternateClinicPhone}
                  onChange={handleInputChange}
                  label="Alernate Phone"
                  fieldName="phone"
                  setInputNumberError={setInputError}
                  placeholder="Enter Alernate Phone"
                   />
              </div>
              <div className="col-md-6">
              <InputEmail name="clinicEmail"
                  value={clinicProfileData.clinicEmail}
                  onChange={handleInputChange}
                  label="Clinic Email"
                  setInputEmailError={setInputError} />
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Tag Line</label>
                  <input
                    type="text"
                    name="tagline"
                    value={clinicProfileData.tagline}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Instagram</label>
                  <input
                    type="text"
                    name="instagram"
                    value={clinicProfileData.instagram}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Youtube</label>
                  <input
                    type="text"
                    name="youtube"
                    value={clinicProfileData.youtube}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Facebook</label>
                  <input
                    type="text"
                    name="facebook"
                    value={clinicProfileData.facebook}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Twitter</label>
                  <input
                    type="text"
                    name="twitter"
                    value={clinicProfileData.twitter}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Country</label>
                  <Select
                    name="country"
                    value={
                      clinicProfileData.clinicAddress.country
                        ? {
                          value: clinicProfileData.clinicAddress.country,
                          label: clinicProfileData.clinicAddress.countryName,
                        }
                        : null
                    }
                    placeholder="Select country"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "country")
                    }
                    options={Country.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>State</label>
                  <Select
                    name="state"
                    value={
                      clinicProfileData.clinicAddress.state
                        ? {
                          value: clinicProfileData.clinicAddress.state,
                          label: clinicProfileData.clinicAddress.stateName,
                        }
                        : null
                    }
                    placeholder="Select state"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "state")
                    }
                    options={state?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>City</label>
                  <Select
                    name="city"
                    value={
                      clinicProfileData.clinicAddress.city
                        ? {
                          value: clinicProfileData.clinicAddress.city,
                          label: clinicProfileData.clinicAddress.cityName,
                        }
                        : null
                    }
                    placeholder="Select city"
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "city")
                    }
                    options={cities?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Area</label>
                  <input
                    name="area"
                    value={clinicProfileData.clinicAddress.area}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>LandMark</label>
                  <input
                    name="landMark"
                    value={clinicProfileData.clinicAddress.landMark}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Street</label>
                  <input
                    name="street"
                    value={clinicProfileData.clinicAddress.street}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Plot/House</label>
                  <input
                    name="plot"
                    value={clinicProfileData.clinicAddress.plot}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <InputPINCode name="pin"
                  value={clinicProfileData.clinicAddress.pin}
                  onChange={handleInputChange}
                  label="PINCODE"
                  setInputPINCodeError={setInputError} />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setDeleteModal(false)} className="p-2">Cancel</Button>
          <Button onClick={handleUpdate} className="p-2">Update</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfileAddEdit;
